export const TIMESHEET_ACCESS_TYPE = {
  ALL_USERS: 'urn:replicon:resource-type:department',
  LOCATIONS: 'urn:replicon:resource-type:location',
  DIVISIONS: 'urn:replicon:resource-type:division',
  COST_CENTERS: 'urn:replicon:resource-type:cost-center',
  SERVICE_CENTERS: 'urn:replicon:resource-type:service-center',
  DEPARTMENT_GROUP: 'urn:replicon:resource-type:department-group',
  EMPLOYEE_TYPE_GROUP: 'urn:replicon:resource-type:employee-type-group'
};
